/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_No_Presets_ToastInputs */



/**
* | output |
* | --- |
* | "No presets to export" |
*
* @param {Preset_Manager_No_Presets_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_no_presets_toast = /** @type {((inputs?: Preset_Manager_No_Presets_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_No_Presets_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun preset a exporter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Voreinstellungen zum Exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun preset da esportare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет предустановок для экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ajustes preestablecidos para exportar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有预设要导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートするプリセットがありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात करने के लिए कोई प्रीसेट नहीं हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há predefinições para exportar.")
	return /** @type {LocalizedString} */ ("No presets to export")
});